import React from "react";
import { Link } from "react-router-dom";
import { LiveDot } from "./ui/Primitives";

const navLinks = [
  { text: "ראשי", to: "/" },
  { text: "אודות", to: "/about" },
  { text: "שירותים", to: "/services" },
  { text: "תיק עבודות", to: "/portfolio" },
  { text: "מערכת צמיחה אוטונומית", to: "/growth-os" },
  { text: "צור קשר", to: "/contact" },
];

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-[var(--line)] bg-ink">
      <div className="shell py-20">
        <div className="grid gap-14 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <Link to="/" className="mb-6 inline-block" aria-label="ELAD DIGITAL">
              <img
                src="/images/logo-mark.png"
                alt="ELAD DIGITAL"
                width={611}
                height={164}
                className="h-11 w-auto object-contain"
              />
            </Link>
            <p className="t-body max-w-xs text-sm">
              סוכנות שיווק דיגיטלי מובילה בישראל. פתרונות מקצה לקצה שמניבים
              תוצאות מוכחות ומדידות.
            </p>
            <div className="mt-6 flex items-center gap-2.5">
              <LiveDot />
              <span className="t-meta">זמין לפרויקטים חדשים</span>
            </div>
          </div>

          <nav aria-label="ניווט תחתון">
            <h4 className="t-meta mb-5">ניווט</h4>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-fg-2 transition-colors duration-200 hover:text-signal"
                  >
                    {link.text}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h4 className="t-meta mb-5">יצירת קשר</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="tel:+972557070007"
                  className="t-data text-sm text-fg-2 transition-colors hover:text-signal"
                  dir="ltr"
                >
                  +972-55-7070007
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@eladkeren.com"
                  className="t-data text-sm text-fg-2 transition-colors hover:text-signal"
                  dir="ltr"
                >
                  info@eladkeren.com
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/972557070007"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-fg-2 transition-colors hover:text-signal"
                >
                  שלחו הודעה בוואטסאפ
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col justify-between gap-3 border-t border-[var(--line)] pt-7 sm:flex-row sm:items-center">
          <p className="t-data text-xs text-fg-3">
            © {currentYear} ELAD DIGITAL. כל הזכויות שמורות.
          </p>
          <p className="text-xs text-fg-3">עוצב ופותח בישראל</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
